export const HALL_TYPE = {
  first: 1,
  second: 2,
  third: 3,
};

export const HALL_TYPE_DATA = {
  [HALL_TYPE.first]: {
    id: HALL_TYPE.first,
    text: 'Прямоугольники',
  },
  [HALL_TYPE.second]: {
    id: HALL_TYPE.second,
    text: 'Квадраты',
  },
  [HALL_TYPE.third]: {
    id: HALL_TYPE.third,
    text: 'Круги',
  },
};

export const HALL_UPLOAD_GRAND = {
  me: 1,
  organizations: 2,
  members: 3,
  everyone: 4,
};

export const HALL_UPLOAD_GRAND_DATA = {
  [HALL_UPLOAD_GRAND.me]: {
    id: HALL_UPLOAD_GRAND.me,
    text: 'Только я',
  },
  [HALL_UPLOAD_GRAND.organizations]: {
    id: HALL_UPLOAD_GRAND.organizations,
    text: 'Организации и я',
  },
  [HALL_UPLOAD_GRAND.members]: {
    id: HALL_UPLOAD_GRAND.members,
    text: 'Участники конкретных мероприятий',
  },
  [HALL_UPLOAD_GRAND.everyone]: {
    id: HALL_UPLOAD_GRAND.everyone,
    text: 'Кто угодно',
  },
};

export const EXPOSITION_STATUS = {
  active: 1,
  draft: 2,
  moderate: 3,
};

export const EXPOSITION_STATUS_DATA = {
  [EXPOSITION_STATUS.active]: {
    id: EXPOSITION_STATUS.active,
    text: 'Активно',
    icon: '$icheck-outline-circle',
    attrs: {
      color: 'redesignSuccess',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [EXPOSITION_STATUS.draft]: {
    id: EXPOSITION_STATUS.draft,
    text: 'Черновик',
    icon: 'mdi-circle-edit-outline',
    attrs: {
      color: 'redesignSecondary',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [EXPOSITION_STATUS.moderate]: {
    id: EXPOSITION_STATUS.moderate,
    text: 'На модерации',
    icon: '$iclock-outline',
    attrs: {
      color: 'redesignWarning',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
};
